import { DialogComponent } from '@theme/dialog';

/**
 * B2B Access Modal Component
 *
 * Displays a modal after a non-B2B customer is logged out. Restriction
 * visits first land on the account request page; this modal only opens
 * when they leave that form without submitting.
 *
 * @extends DialogComponent
 */
export class B2BAccessModal extends DialogComponent {
  static SESSION_KEY = 'b2b_access_denied';
  static EMAIL_KEY = 'b2b_denied_email';
  static LOGIN_KEY = 'b2b_go_to_login';

  connectedCallback() {
    super.connectedCallback();

    if (sessionStorage.getItem(B2BAccessModal.LOGIN_KEY) === 'true') {
      sessionStorage.removeItem(B2BAccessModal.LOGIN_KEY);
      sessionStorage.removeItem(B2BAccessModal.SESSION_KEY);
      sessionStorage.removeItem(B2BAccessModal.EMAIL_KEY);

      const loginUrl = this.dataset.loginUrl;
      if (loginUrl) {
        window.location.assign(loginUrl);
        return;
      }
    }

    if (sessionStorage.getItem(B2BAccessModal.SESSION_KEY) === 'true') {
      this.#applyNoAccountCopy();
      requestAnimationFrame(() => {
        this.showDialog();
        /** @type {HTMLElement | null} */ (document.activeElement)?.blur();
      });
    }
  }

  /**
   * When the restriction flow stored an email, swap the generic access
   * copy for the "couldn't find an account" message and two actions.
   */
  #applyNoAccountCopy() {
    const email = sessionStorage.getItem(B2BAccessModal.EMAIL_KEY) || '';
    const { defaultContent, noAccountContent, noAccountLead, noAccountEmail } = this.refs;

    if (!email || !(noAccountContent instanceof HTMLElement)) return;

    if (defaultContent instanceof HTMLElement) defaultContent.hidden = true;
    noAccountContent.hidden = false;

    const template = this.dataset.noAccountHeading || noAccountLead?.textContent || '';
    const parts = template.split('[email]');

    if (noAccountLead) {
      noAccountLead.textContent = parts[0] || '';
    }

    if (noAccountEmail) {
      noAccountEmail.hidden = false;
      noAccountEmail.textContent = `${email}${(parts[1] || '').trim()}`;
    }
  }

  /**
   * Clears the sessionStorage flags.
   * Called when the customer uses Request account or Log in.
   */
  clearFlag() {
    sessionStorage.removeItem(B2BAccessModal.SESSION_KEY);
    sessionStorage.removeItem(B2BAccessModal.EMAIL_KEY);
    sessionStorage.removeItem(B2BAccessModal.LOGIN_KEY);
  }
}

if (!customElements.get('b2b-access-modal')) {
  customElements.define('b2b-access-modal', B2BAccessModal);
}
